import { render, staticRenderFns } from "./ChargerIcon-2.vue?vue&type=template&id=d45f9a84&"
import script from "./ChargerIcon-2.vue?vue&type=script&lang=js&"
export * from "./ChargerIcon-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports